import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { StorageManager } from '../../../common/storage-manager.class';

type Severity = 'danger' | 'info' | 'primary';

@Component({
  selector: 'app-action-buttons',
  standalone: false,
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionButtonsComponent {
  /* Visibility toggles */
  @Input() hideInfo = false;
  
  @Input() hideEdit = false;
  
  @Input() hideDelete = false;
  
  @Input() showDuplicate = false;

  /* Notification dot */
  @Input() showNotification = false;
  
  @Input() notificationCount = 0;
  
  @Input() notificationSeverity: Severity = 'danger';

  /* Events */
  @Output() editRowButtonEvent = new EventEmitter<object>();
  
  @Output() deleteRowButtonEvent = new EventEmitter<object>();
  
  @Output() showRowButtonEvent = new EventEmitter<object>();
  
  @Output() duplicateRowButtonEvent = new EventEmitter<object>();

  /* Env flags (read once) */
  readonly flags = {
    userSoloCanSeeInfo: environment.features.userSoloCanSeeInfo,
    userCanDeleteRecords: environment.features.userCanDeleteRecords,
    showInfoCambios: environment.features.showInfoCambios,
    appName: environment.appName,
    tareasMto: environment.features.showTareasMto,
  };

  private readonly userRol = StorageManager.getUser().rol;

  /* Computed permissions (kept simple and explicit) */
  get canEdit(): boolean {
    if (this.hideEdit) {return false;}
    if (this.flags.userSoloCanSeeInfo) {return false;}
    if (this.userRol === 'demo' || this.userRol === 'gerencia') {return false;}
    if (this.userRol === 'aplicador' && this.flags.appName !== 'detorres') {
      // excepciones por app
      return ['ava', 'tomega'].includes(this.flags.appName);
    }
    return true;
  }

  get canDelete(): boolean {
    if (this.hideDelete) {return false;}
    if (!this.flags.userCanDeleteRecords) {return false;}
    if (this.flags.tareasMto && this.flags.appName !== 'detorres') {return false;}
    if (this.userRol === 'demo' || this.userRol === 'gerencia') {return false;}
    if (this.flags.appName === 'covidai') {
      return this.userRol === 'admin';
    }
    if (this.userRol === 'aplicador' && this.flags.appName !== 'detorres') {
      return false;
    }
    return true;
  }

  get canDuplicate(): boolean {
    if (!this.showDuplicate) {return false;}
    if (this.userRol === 'gerencia') {return false;}
    if (this.userRol === 'aplicador' && this.flags.appName !== 'detorres') {return false;}
    return true;
  }

  get showInfo(): boolean {
    return !this.hideInfo;
  }

  get showBadge(): boolean {
    return this.flags.showInfoCambios && this.showNotification;
  }

  // Text shown in tiny badge
  get badgeText(): string {
    return this.notificationCount > 0 ? String(this.notificationCount) : '!';
  }
}
